// extracted by mini-css-extract-plugin
export default {"iconoTopBar":"DatoContacto_iconoTopBar__72d9l"};